import { useEffect } from "react";

import { zipObject } from "../../../../helpers/JSONTransformations";
import { INITIAL_COLUMNS } from "./constants.js";

const useEditProductEffect = ({ product, setColumns, setRows, sidebarIsOpen }) =>
  useEffect(() => {
    if (product && Object.keys(product).length && !!product.variants[0]) {
      setColumns(
        INITIAL_COLUMNS.slice(0, -1).concat(
          product.options.map((option, index) => ({
            id: option.id,
            title: option.name,
            placeholder: "Option Value",
            stateKey: `variantOption${index + 3}`,
            variantOption: true
          }))
        )
      );

      setRows(
        product.variants.map(({ id, price, stock, sku, ...variant }) => ({
          id,
          price,
          stock,
          sku,
          ...zipObject(
            variant.selectedValues.map((selectedValue, index) => ({
              key: `variantOption${index + 3}`,
              value: selectedValue.name
            }))
          )
        }))
      );
    }
  }, [product, sidebarIsOpen]);

export default useEditProductEffect;
